import { useRequest } from '@/hooks/useRequest';
import { API_PATH, ModuleType } from '@/types/shared';
// import { mockActivityQueryResult, mockActivityQueryResultAfterDraw } from '@/utils/mock';
// 是否使用 Mock 数据
const USE_MOCK = false;
export function useQueryActivityInfo() {
    const { request, requestStatus } = useRequest(API_PATH.MAIN, {
        showLoading: false
    });
    const queryActivityInfo = async (params) => {
        // if (USE_MOCK) {
        //   // 模拟网络延迟
        //   await new Promise(resolve => setTimeout(resolve, 500));
        //   return getMockQueryResult();
        // }
        Object.assign(params, {
            scene: 1
        });
        return request(params);
    };
    return {
        queryActivityInfo,
        requestStatus
    };
}
// 用于记录哪些券已经被领取
// const drawnPrizeBatchIds = new Set<string>();
export function useDrawPrize() {
    const { request, requestStatus } = useRequest(API_PATH.DRAW_PRIZE, {
        showLoading: true,
        loadingText: '领取中...'
    });
    const drawPrize = async (params) => {
        // if (USE_MOCK) {
        //   // 模拟网络延迟
        //   await new Promise(resolve => setTimeout(resolve, 800));
        //   // 获取要领取的券批次ID
        //   const prizeBatchId = Object.keys(params.prizeBatchId2TypeMap)[0];
        //   drawnPrizeBatchIds.add(prizeBatchId);
        //   // 找到对应的券信息
        //   const prizeInfo = mockActivityQueryResult.moduleInfoList[0].rewardModuleInfoVO!.userPrizeInfos.find(
        //     p => p.prizeBatchId === prizeBatchId
        //   );
        //   if (!prizeInfo) {
        //     return null;
        //   }
        //   // 返回领取成功的结果
        //   return {
        //     userPrizeInfos: [
        //       {
        //         ...prizeInfo,
        //         prizeStatus: 3, // 未使用
        //         drawTime: Date.now(),
        //         drawTimeDesc: '刚刚',
        //       },
        //     ],
        //   };
        // }
        Object.assign(params, {
            moduleType: ModuleType.REWARD,
            drawExtraInfo: {
                scene: 1
            }
        });
        return request({
            activityId: params.activityId,
            activityName: params.activityName,
            drawParam: params
        });
    };
    return {
        drawPrize,
        requestStatus
    };
}
/**
 * 获取查询活动信息时的数据（考虑已领取的券）
 */
// export function getMockQueryResult(): MarketingActivityQueryResult {
//   if (drawnPrizeBatchIds.size === 0) {
//     return mockActivityQueryResult;
//   }
//   return {
//     moduleInfoList: [
//       {
//         rewardModuleInfoVO: {
//           style: 3,
//           userPrizeInfos: mockActivityQueryResult.moduleInfoList[0].rewardModuleInfoVO!.userPrizeInfos.map(prize => {
//             if (drawnPrizeBatchIds.has(prize.prizeBatchId)) {
//               return {
//                 ...prize,
//                 prizeStatus: 3, // 未使用
//                 drawTime: Date.now(),
//                 drawTimeDesc: '刚刚',
//               };
//             }
//             return prize;
//           }),
//         },
//       },
//     ],
//   };
// }
